import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const Navigation: React.FC = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Announcement Banner */}
      <div className="bg-accent text-white text-center py-2 text-sm font-medium">
        🏢 Toronto Area Showroom Coming Soon! | Call: (905) 674-5983
      </div>

      <nav className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center min-w-0">
              <img
                src="images/logo/evie_outdoors_transparent.png"
                alt="Evie Outdoors Logo"
                className="h-8 w-auto mr-2 sm:h-10 sm:mr-3 flex-shrink-0"
              />
              <Link
                to="/"
                className="text-lg sm:text-2xl font-bold text-primary hover:text-accent transition-colors truncate"
              >
                Evie Outdoors
              </Link>
            </div>

            <div className="hidden lg:flex items-center space-x-8">
              <Link to="/pergolas" className="text-gray-700 hover:text-accent">
                Pergolas
              </Link>
              <Link to="/awnings" className="text-gray-700 hover:text-accent">
                Awnings
              </Link>
              <a
                href="tel:+19056745983"
                className="text-accent hover:text-green-700 font-semibold flex items-center gap-1"
              >
                📞 (905) 674-5983
              </a>
            </div>

            {/* Mobile menu button */}
            <div className="lg:hidden">
              <button
                id="mobile-menu-button"
                onClick={toggleMobileMenu}
                className="p-2 text-gray-700 hover:text-accent focus:outline-none focus:text-accent"
              >
                <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={isMobileMenuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"}
                  />
                </svg>
              </button>
            </div>
          </div>

          {/* Mobile menu */}
          <div
            id="mobile-menu"
            className={`lg:hidden ${isMobileMenuOpen ? 'block' : 'hidden'}`}
          >
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 bg-white border-t">
              <Link
                to="/pergolas"
                className="block px-3 py-2 text-gray-700 hover:text-accent"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Pergolas
              </Link>
              <Link
                to="/awnings"
                className="block px-3 py-2 text-gray-700 hover:text-accent"
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Awnings
              </Link>
              <div className="border-t pt-2 mt-2">
                <a
                  href="tel:+19056745983"
                  className="block px-3 py-2 text-accent hover:text-green-700 font-semibold"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  📞 Call: (905) 674-5983
                </a>
                <a
                  href="tel:+18554744653"
                  className="block px-3 py-2 text-accent hover:text-green-700 font-semibold"
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  📞 Toll Free: (855) 474-4653
                </a>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
};

export default Navigation;
